import Axios from "axios";

import { apiUrl, serializeObjToGetStr } from "../../constants";
import { fileDownloader } from "../file-downloader.service";

const downloadBaseUrl = `${apiUrl}/download`;
const config = {
    headers: { "Content-Type": "application/json-patch+json" }
};

export const importExportApi = {

  downloadEmptyExcel: (request, fileName) => {
    const query = serializeObjToGetStr(request);
    fileDownloader.download(`${downloadBaseUrl}/download-empty-excel`, fileName);
  },

  import: filePath => {
    const formData = new FormData();
    formData.append("file", filePath);
    const headers = { "Content-Type": "multipart/form-data" };

    return Axios.post(`${downloadBaseUrl}/import`, formData, {headers});
  },

  downloadInventoryExport: (request, fileName) => {
    const query = serializeObjToGetStr(request);
    return fileDownloader.download(`${downloadBaseUrl}/inventory/?${query}`, fileName);
  },

  downloadDeviceTypeExport: (request, fileName) => {
    const query = serializeObjToGetStr(request);
    return fileDownloader.download(`${downloadBaseUrl}/download-device-types?${query}`, fileName);
  },
  downloadCostCenterExport: (request, fileName) => {
    const query = serializeObjToGetStr(request);
    return fileDownloader.download(`${downloadBaseUrl}/download-cost-centers?${query}`, fileName);
  },
  downloadSiteExport: (request, fileName) => {
    const query = serializeObjToGetStr(request);
    return fileDownloader.download(`${downloadBaseUrl}/download-sites?${query}`, fileName);
  },
  downloadLocationExport: (request, fileName) => {
    const query = serializeObjToGetStr(request);
    return fileDownloader.download(`${downloadBaseUrl}/download-locations?${query}`, fileName);
  },
  downloadProductStateExport: (request, fileName) => {
    const query = serializeObjToGetStr(request);
    return fileDownloader.download(`${downloadBaseUrl}/download-product-states?${query}`, fileName);
  },
  downloadProductExport: (request, fileName) => {
    const query = serializeObjToGetStr(request);
    return fileDownloader.download(`${downloadBaseUrl}/download-products?${query}`, fileName);
  },
  downloadArchivedProductExport: (request, fileName) => {
    const query = serializeObjToGetStr(request);
    return fileDownloader.download(`${downloadBaseUrl}/download-archived-products?${query}`, fileName);
  },
  downloadUHJProductExport: (request, fileName) => {
    const query = serializeObjToGetStr(request);
    return fileDownloader.download(`${downloadBaseUrl}/download-uhj-products?${query}`, fileName);
  },
  downloadAuditExport: (request, fileName) => {
    const query = serializeObjToGetStr(request);
    return fileDownloader.download(`${downloadBaseUrl}/download-audit?${query}`, fileName);
  },
  downloadInventoryReportExport: (request, fileName) => {
    const query = serializeObjToGetStr(request);
    return fileDownloader.download(`${downloadBaseUrl}/inventory-report?${query}`, fileName);
  },
};
